import type { CSSProperties, ReactNode } from 'react';
import { Icon } from '../core/Icon';

export interface StepperStep {
    label: string;
    /** Texto de apoio. Só aparece na orientação vertical. */
    hint?: ReactNode;
}

export interface StepperProps {
    steps?: StepperStep[];
    /** Índice do passo atual, base zero. */
    current?: number;
    orientation?: 'horizontal' | 'vertical';
    style?: CSSProperties;
}

export function Stepper({ steps = [], current = 0, orientation = 'horizontal', style }: StepperProps) {
    const horiz = orientation === 'horizontal';
    return (
        <ol style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: horiz ? 'row' : 'column', gap: horiz ? 0 : 14, ...style }}>
            {steps.map((s, i) => {
                const done = i < current;
                const active = i === current;
                return (
                    <li
                        key={s.label}
                        aria-current={active ? 'step' : undefined}
                        style={{ display: 'flex', alignItems: horiz ? 'center' : 'flex-start', gap: 10, flex: horiz ? 1 : undefined, minWidth: 0 }}
                    >
                        <span
                            style={{
                                width: 22, height: 22, flex: '0 0 auto', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                background: done ? 'var(--burgundy-700)' : active ? 'var(--surface)' : 'var(--surface-secondary)',
                                border: `1px solid ${done || active ? 'var(--burgundy-700)' : 'var(--border-strong)'}`,
                                color: done ? '#fff' : active ? 'var(--text-brand)' : 'var(--text-tertiary)',
                                fontSize: 11.5, fontWeight: 600,
                            }}
                        >
                            {done ? <Icon name="check" size={12} /> : i + 1}
                        </span>
                        <span style={{ minWidth: 0 }}>
                            <span style={{ display: 'block', fontSize: 13, fontWeight: active ? 600 : 500, color: active || done ? 'var(--text-primary)' : 'var(--text-secondary)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {s.label}
                            </span>
                            {s.hint && !horiz && <span style={{ display: 'block', fontSize: 12.5, color: 'var(--text-tertiary)' }}>{s.hint}</span>}
                        </span>
                        {horiz && i < steps.length - 1 && (
                            <span aria-hidden="true" style={{ flex: 1, height: 1, background: done ? 'var(--burgundy-200)' : 'var(--border)', margin: '0 12px' }} />
                        )}
                    </li>
                );
            })}
        </ol>
    );
}
